
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9kbAI", function(module, exports) {

$parcel$export(module.exports, "MenuList", () => $e769d84ead345f3c$export$d4c4e98c5044dc8);

var $dM2NO = parcelRequire("dM2NO");
const $e769d84ead345f3c$export$d4c4e98c5044dc8 = (0, $dM2NO.List);

});

parcelRegister("4GOhN", function(module, exports) {

$parcel$export(module.exports, "PrimaryItemList", () => $762a001f36e53e03$export$d54a2a652e3389a4);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $6F6hl = parcelRequire("6F6hl");

var $9kbAI = parcelRequire("9kbAI");

var $lujnM = parcelRequire("lujnM");

var $93uIp = parcelRequire("93uIp");

var $9wGTI = parcelRequire("9wGTI");

var $bQm3c = parcelRequire("bQm3c");

var $euL71 = parcelRequire("euL71");
const $762a001f36e53e03$var$i18n = (0, $2nPZH.defineMessages)({
    searchResult: {
        id: "admin-side-navigation.search-result.number",
        defaultMessage: "{count, plural, =0 {No settings were found that match your search} one {{count} setting found} other {{count} settings found}}"
    }
});
const $762a001f36e53e03$var$PrimaryItem = ({ title: title, href: href, isSelected: isSelected, elemBefore: elemBefore, elemAfter: elemAfter, onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lujnM.LinkMenuItem), {
        isSelected: isSelected,
        href: href,
        elemBefore: elemBefore,
        elemAfter: elemAfter,
        onClick: onClick
    }, title);
const $762a001f36e53e03$export$d54a2a652e3389a4 = ({ primaryItems: primaryItems })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const isOnboardingEdition = edition === (0, $euL71.ConfluenceEdition).FREE || edition === (0, $euL71.ConfluenceEdition).STANDARD;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9kbAI.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6F6hl.default), {
        role: "status"
    }, formatMessage($762a001f36e53e03$var$i18n.searchResult, {
        count: primaryItems?.length
    })), primaryItems.map((item, index)=>item.title === 'Automation' && isOnboardingEdition && (0, $9wGTI.fg)('a4c_free_and_standard_onboarding') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $93uIp.AutomationOnboardingLoader), {
            key: `${index}-${item.title}`,
            analyticsSubject: "spaceSettingsNavigation",
            spotlightTarget: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($762a001f36e53e03$var$PrimaryItem, item)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($762a001f36e53e03$var$PrimaryItem, {
            key: `${index}-${item.title}`,
            ...item
        })));
};

});


//# sourceMappingURL=SpaceSettingsSideNavigation.a8da810b.js.map
